import { motion } from 'framer-motion';
import styled from 'styled-components';

import { designColor } from '@pkg/primitives';

import { PopoverVariant, popoverVariants } from './Popover.motion';

const popoverWidth = 320;

///
/// Popover

export const StyledPopover = styled(motion.div).attrs({
    variants: popoverVariants,
    initial: PopoverVariant.Hidden,
    animate: PopoverVariant.Show,
    exit: PopoverVariant.Hidden,
})<{ $alignRight?: boolean }>`
    position: absolute;
    // TODO: Should relate to a source of truth for stacking context.
    z-index: 10;
    right: ${({ $alignRight }) => ($alignRight ? 0 : 'auto')};
`;

export const Interior = styled.div`
    padding: 20px;
    width: ${popoverWidth}px;
    border-radius: 10px;
    background-color: ${designColor.coal};
`;
